module.exports = __webpack_public_path__ + "static/media/warehouse-icon-w.46d29717.svg";